import React, { useState } from "react";
import { Button, Menu, Typography, Fade } from "@mui/material";

function MenuComponent({
  children,
  text,
  buttonStyle,
  textVariant,
  buttonVariant,
  icons,
  textStyle,
  paperStyle,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "left",
  },
  disabled = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        disabled={disabled}
        variant={buttonVariant}
        id="fade-button"
        aria-controls="fade-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          backgroundColor: disabled && "#F5F5F5",
          borderColor: disabled && "#D6D6D6 !important",
          padding: "0 6px 0 12px",
          ...buttonStyle,
        }}
      >
        {text ? (
          <Typography
            variant={textVariant}
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              textTransform: "none",
              ...textStyle,
            }}
          >
            {text}
          </Typography>
        ) : null}
        {icons}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          style: {
            ...paperStyle,
          },
        }}
      >
        {children}
      </Menu>
    </div>
  );
}

export default MenuComponent;
